import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2ae339ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100%"},
  class: "p-d-flex p-jc-center p-ai-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    height: "200",
    src: "/empty_cart.svg"
  })
], -1))
const _hoisted_3 = {
  class: "overflow-text",
  style: {"font-size":"14px"}
}
const _hoisted_4 = {
  key: 0,
  class: "overflow-text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "p-ml-1 pi pi-pencil" }, null, -1))
const _hoisted_6 = {
  class: "overflow-text",
  style: {"text-align":"center"}
}
const _hoisted_7 = {
  style: {"font-size":"1.4em"},
  class: "p-text-bold p-ml-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PosFindClient = _resolveComponent("PosFindClient")!
  const _component_POSDiscount = _resolveComponent("POSDiscount")!
  const _component_ProductName = _resolveComponent("ProductName")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PaymentReceipt = _resolveComponent("PaymentReceipt")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PrintSetupDialog = _resolveComponent("PrintSetupDialog")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.ticketRows,
      rows: _ctx.ticketRows.length,
      class: "p-datatable-sm",
      dataKey: "index",
      "responsive-layout": "scroll",
      "row-hover": false,
      scrollable: "",
      "scroll-height": "flex",
      paginator: _ctx.ticketRows.length > 0
    }, {
      header: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_PosFindClient, {
            currentCustomer: _ctx.ticket[0]?.customer,
            modelValue: _ctx.customer,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer) = $event)),
            disabled: _ctx.resume.recover || _ctx.resume.disabled,
            fromRecover: _ctx.recover || _ctx.isModification
          }, null, 8, ["currentCustomer", "modelValue", "disabled", "fromRecover"]),
          _createVNode(_component_POSDiscount, {
            fromRecover: _ctx.recover || _ctx.isModification,
            "ticket-amount": _ctx.dicountSettings.offerAmount,
            "ticket-percentage": _ctx.dicountSettings.offerPercentage,
            ticketId: _ctx.ticket[0]?.id,
            total: _ctx.resume.total,
            amount: _ctx.ticketAfterPay.amount,
            "onUpdate:amount": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ticketAfterPay.amount) = $event)),
            percent: _ctx.ticketAfterPay.percentage,
            "onUpdate:percent": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ticketAfterPay.percentage) = $event)),
            disabled: _ctx.resume.recover || _ctx.resume.disabled
          }, null, 8, ["fromRecover", "ticket-amount", "ticket-percentage", "ticketId", "total", "amount", "percent", "disabled"]),
          _renderSlot(_ctx.$slots, "remove", {}, undefined, true)
        ]),
        _renderSlot(_ctx.$slots, "ticket-infos", {}, undefined, true)
      ]),
      empty: _withCtx(() => [
        _hoisted_2
      ]),
      paginatorstart: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("payment.discount")) + " ( ", 1),
        _createVNode(_component_NumberFormatter, {
          discount: true,
          value: _ctx.ticketAfterPay.percentage || _ctx.dicountSettings.offerPercentage
        }, null, 8, ["value"]),
        _createTextVNode(" % ) ")
      ]),
      paginatorend: _withCtx(() => [
        _createVNode(_component_NumberFormatter, {
          value: _ctx.ticketAfterPay.amount || _ctx.dicountSettings.offerAmount
        }, null, 8, ["value"]),
        _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
      ]),
      footer: _withCtx(() => [
        _renderSlot(_ctx.$slots, "code-bar", {}, undefined, true),
        ([0, 3].includes(_ctx.ticket[0]?.status))
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              disabled: !_ctx.freeTerminal,
              icon: "pi pi-pencil",
              class: "p-col-6 p-button-warning p-py-4",
              label: _ctx.$t('modify'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('modify')))
            }, null, 8, ["disabled", "label"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.resume.recover)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    disabled: _ctx.recoverLoading || !_ctx.freeTerminal,
                    icon: "pi pi-refresh",
                    class: "p-col-6 p-button-warning p-py-4",
                    label: _ctx.$t('recover'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitRecover(_ctx.ticket[0].id))),
                    loading: _ctx.recoverLoading
                  }, null, 8, ["disabled", "label", "loading"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    loading: _ctx.cStatus === 2 && _ctx.creationLoading,
                    icon: "pi pi-pause",
                    class: "p-col-6 p-button-warning p-py-4",
                    label: _ctx.$t('ticket.wait'),
                    disabled: _ctx.disablePause,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSubmitTicket()))
                  }, null, 8, ["loading", "label", "disabled"]))
            ], 64)),
        _createVNode(_component_Button, {
          "aria-haspopup": "true",
          "aria-controls": "printerOverlay",
          "icon-pos": "right",
          icon: "pi pi-print",
          class: "p-col-6 p-py-4",
          label: `${_ctx.$t('pos.print')} ${
          _ctx.ticket[0]?.number
            ? _ctx.$t('ticket.number', { number: _ctx.ticket[0].number })
            : ''
        }`,
          onClick: _ctx.onClickPrint,
          loading: _ctx.btnPrinterEnable > 0,
          disabled: _ctx.disablePrinter
        }, null, 8, ["label", "onClick", "loading", "disabled"]),
        _createVNode(_component_Button, {
          disabled: _ctx.disablePayment,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.paymentDialog = true)),
          class: "p-col-12 p-d-flex p-jc-center p-button-success p-py-4",
          style: {"font-size":"1.3em"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              style: {"font-size":"1.4em"},
              class: _normalizeClass(`p-mr-3 pi pi-${
            _ctx.cStatus !== 2 && _ctx.creationLoading ? 'spinner' : 'money-bill'
          }`)
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.ticket[0]?.status === 1 ? "pay" : "validate") + " :") + " ", 1),
            _createElementVNode("span", _hoisted_7, [
              (_ctx.resume.tAfterPay >= _ctx.resume.receivedSum)
                ? (_openBlock(), _createBlock(_component_NumberFormatter, {
                    key: 0,
                    value: _ctx.resume.tAfterPay - _ctx.resume.receivedSum
                  }, null, 8, ["value"]))
                : (_openBlock(), _createBlock(_component_NumberFormatter, {
                    key: 1,
                    value: _ctx.resume.tAfterPay
                  }, null, 8, ["value"])),
              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
            ])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_PaymentReceipt, {
          resume: _ctx.resume,
          ticket: _ctx.ticket[0],
          onValidate: _ctx.onSubmitTicket,
          customer: _ctx.customer,
          print: _ctx.printAfterPay,
          "onUpdate:print": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.printAfterPay) = $event)),
          discount: _ctx.ticketAfterPay.amount,
          visible: _ctx.paymentDialog,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.paymentDialog) = $event)),
          loading: _ctx.updateTicketLoading || _ctx.creationLoading
        }, null, 8, ["resume", "ticket", "onValidate", "customer", "print", "discount", "visible", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          style: {"min-width":"25%"},
          header: _ctx.$t('product.name'),
          field: "name",
          sortable: true,
          "body-class": "p-d-flex p-flex-column p-jc-center"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_ProductName, { product: data }, {
              default: _withCtx(({ name, reference, discount }) => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(name), 1),
                (_ctx.printBarcode && !discount)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t("product.ref")) + " : " + _toDisplayString(reference), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["product"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          "header-class": "flex p-justify-center",
          "body-class": "flex p-justify-center",
          style: {"min-width":"130px"},
          header: _ctx.$t('product.quantity'),
          field: "quantity"
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_ProductName, {
              product: slotProps.data
            }, {
              default: _withCtx(({ discount }) => [
                (_ctx.resume.editableQuantity && !discount)
                  ? (_openBlock(), _createBlock(_component_InputNumber, {
                      key: 0,
                      style: {"height":"30px"},
                      "model-value": slotProps.data.quantity,
                      onInput: ($event: any) => (slotProps.data.quantity = $event.value),
                      onKeyup: ($event: any) => (
              slotProps.data.quantity = _ctx.extractNumber($event.target.value)
            ),
                      onKeydown: _ctx.onKeyPress,
                      showButtons: "",
                      "input-class": "p-text-center",
                      buttonLayout: "horizontal",
                      decrementButtonClass: "p-button-danger",
                      incrementButtonClass: "p-button-success",
                      incrementButtonIcon: "pi pi-plus",
                      decrementButtonIcon: "pi pi-minus",
                      mode: "decimal",
                      "input-style": "max-width: 90px!important",
                      format: false,
                      min: 0,
                      "max-fraction-digits": 20,
                      "onUpdate:modelValue": ($event: any) => (_ctx.onEdit(slotProps, $event))
                    }, null, 8, ["model-value", "onInput", "onKeyup", "onKeydown", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock(_component_NumberFormatter, {
                      key: 1,
                      value: slotProps.data.quantity
                    }, null, 8, ["value"]))
              ]),
              _: 2
            }, 1032, ["product"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          "header-class": "flex p-justify-center",
          "body-class": "flex p-justify-center",
          style: {"min-width":"120px"},
          header: _ctx.$t('pos.upTax')
        }, {
          body: _withCtx(({ data, index }) => [
            (data.changeable !== null)
              ? (_openBlock(), _createBlock(_component_Inplace, {
                  key: 0,
                  active: data.changeable,
                  "onUpdate:active": ($event: any) => ((data.changeable) = $event)
                }, {
                  display: _withCtx(() => [
                    _createVNode(_component_NumberFormatter, {
                      value: data.price
                    }, null, 8, ["value"]),
                    _hoisted_5
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      id: `price${index}`,
                      onfocus: "this.select();",
                      class: "p-text-center",
                      "model-value": data.price,
                      onBlur: ($event: any) => (_ctx.onPriceEdit(index, ($event.target as any).value)),
                      onKeyup: _withKeys(($event: any) => (_ctx.onPriceEdit(index, ($event.target as any).value)), ["enter"]),
                      style: {"max-width":"100px !important"}
                    }, null, 8, ["id", "model-value", "onBlur", "onKeyup"])
                  ]),
                  _: 2
                }, 1032, ["active", "onUpdate:active"]))
              : (_openBlock(), _createBlock(_component_NumberFormatter, {
                  key: 1,
                  value: data.price
                }, null, 8, ["value"]))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          "header-class": "flex p-justify-center",
          "body-class": "flex p-justify-center",
          style: {"min-width":"80px"},
          header: _ctx.$t('pos.inTax')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_NumberFormatter, {
                value: data.price * data.quantity
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        (!_ctx.ticket.length)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              style: {"max-width":"52px"},
              "header-class": "flex p-justify-center",
              "body-class": "flex p-justify-center",
              header: "Ctrl"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  onClick: ($event: any) => (_ctx.$emit('remove-row', slotProps.index)),
                  icon: "pi pi-trash",
                  class: "p-button-sm p-button-text p-button-warning p-button-rounded"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["value", "rows", "paginator"]),
    (_ctx.printSetupDialog.show)
      ? (_openBlock(), _createBlock(_component_PrintSetupDialog, {
          key: 0,
          option: _ctx.printSetupDialog.option,
          ticket: _ctx.ticketAfterPay,
          "onUpdate:ticket": _cache[9] || (_cache[9] = ($event: any) => (_ctx.printBuild($event, _ctx.printSetupDialog.option))),
          modelValue: _ctx.printSetupDialog.show,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.printSetupDialog.show) = $event))
        }, null, 8, ["option", "ticket", "modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      "close-on-escape": "",
      modal: "",
      "show-header": false,
      position: "bottomright",
      style: { width: 'auto' },
      "dismissable-mask": "",
      visible: _ctx.printerOverlay,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.printerOverlay) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Menu, {
          style: {"padding-bottom":"15px","margin-top":"15px","width":"100%"},
          model: _ctx.printOptions
        }, null, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}